"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var manager_1 = require("./manager");
var React = require("react");
/**
 * Crea el componente para mostrar los dialogos y la función para mostrar un modal. Para utilizarlo dibuje el componente en cuarlquier parte de su
 * nodo de React y llame a la función showModal. La función mostrará el cuadro de diálogo al ser llamada y devolverá una promesa que se resolverá cuando
 * el usuario cierre el modal, devolviendo el resultado y el valor del modal
 */
function createModalManager() {
    //Mantenemos una cola de las llaamdas al show modal en caso de que la función show modal se llame antes de que este disponible la referencia al componente
    var instance = undefined;
    var queue = [];
    var processQueue = function () {
        while (instance && queue.length > 0) {
            var value = queue.pop();
            if (value) {
                value(instance);
            }
        }
    };
    var handleRef = function (x) {
        instance = x;
        processQueue();
    };
    var component = React.createElement(manager_1.ModalManager, { ref: handleRef });
    var showModal = function (component, params, value) {
        return new Promise(function (resolve) {
            queue.push(function (i) { return i.showModal(component, params, value).then(function (x) { return resolve(x); }); });
            processQueue();
        });
    };
    return { component: component, showModal: showModal };
}
exports.createModalManager = createModalManager;
//# sourceMappingURL=create.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-modal-manager/dist/create.js
// module id = 2485
// module chunks = 0